import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import * as CryptoJS from 'crypto-js';
import "rxjs/add/operator/map";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { MysqlService } from '../../../services/mysql.service';

import { AddFarmPage } from '../addFarm/addFarm';
import { FarmDashboardPage } from '../farmDashboard/farmDashboard';

@Component({
  selector: 'page-farmList',
  templateUrl: 'farmList.html',
  // styleUrls: [ 'farmList.scss', '../../theme/variables.scss' ]

})
export class FarmListPage {

  public myreturnvalue;
  public loading;
  public prompt;
  public goshalas: any;
  public continents: any;
  public stat: any = {};

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: Http,
    public loadingCtrl: LoadingController,
    public myApp: ImcpaAppProvider,
    private dbService: MysqlService
  ) {
    this.getStats();
      // this.presentLoading();
      // this.initializeItems();
      // this.goshalas = this.myApp.getGoshalas();
  }

  initializeItems() {
    // this.goshalas = this.myApp.getGoshalas();
    this.getGoshalas();
  }

  searchGoshalas(ev: any){
    this.prompt = ''
    console.log(ev.target);
    const val = ev.target.value;
    this.presentLoading();
    this.getContinentSearched(val);  
  }

  getContinentSearched(val){
    let mysql = "";
    if(val === 'registered'){
      mysql = "select (select COUNT(*) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0) AS farmCount, (select count(*) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0) as registeredCount, ifnull((select sum(f1.totalCows) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0),0) as cowsCount, ifnull((select sum(f1.totalCalves) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0),0) as calvesCount, ifnull((select sum(f1.totalBulls) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0),0) as bullsCount, ifnull((select sum(f1.totalOx) from farms f1 where  f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0),0) as oxenCount, ifnull((select sum(f1.totalMilkDayLtrs) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0),0) as milkLtrs, f.continent from farms f where f.id != 0 and f.registered = 'Y' group by f.continent order by f.continent"
    }
    if(val !== 'registered') {
      mysql = "SELECT (select COUNT(*) from farms f1 where f1.continent = f.continent and f1.id != 0) AS farmCount, (select count(*) from farms f1 where f1.registered = 'Y' and f1.continent = f.continent and f1.id != 0) as registeredCount, ifnull((select sum(f1.totalCows) from farms f1 where f1.continent = f.continent and f1.id != 0),0) as cowsCount, ifnull((select sum(f1.totalCalves) from farms f1 where f1.continent = f.continent and f1.id != 0),0) as calvesCount, ifnull((select sum(f1.totalBulls) from farms f1 where f1.continent = f.continent and f1.id != 0),0) as bullsCount, ifnull((select sum(f1.totalOx) from farms f1 where f1.continent = f.continent and f1.id != 0),0) as oxenCount, ifnull((select sum(f1.totalMilkDayLtrs) from farms f1 where f1.continent = f.continent and f1.id != 0),0) as milkLtrs, f.continent FROM farms f where f.id != 0 and name LIKE '%" + val + "%' OR country LIKE '%" + val + "%' OR continent LIKE '%" + val + "%' OR region LIKE '%" + val + "%' group by continent order by f.continent"
    }
    this.dbService.fetchDataV2(mysql)
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.continents=res.data;
        
        console.log(this.continents);
        this.getGoshalaSearched(val)
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
    }


  getGoshalaSearched(val){
    let mysql = "";
    if(val === 'registered'){
      mysql = "select f.* from farms f where f.registered = 'Y' and f.id != 0"
    }
    if(val !== 'registered') {
      mysql = "SELECT f.* from farms f where f.id != 0 and name LIKE '%" + val + "%' OR country LIKE '%" + val + "%' OR continent LIKE '%" + val + "%' OR region LIKE '%" + val + "%' order by f.name, f.continent"
    }
    this.dbService.fetchDataV2(mysql)
      .map(res => res.json())
      .subscribe(res => {
        this.loading.dismiss();
        this.goshalas=res.data;
        if(this.goshalas.length === 0 ){
          this.prompt = "No Records Found";
        } else {
          console.log("val = " + val)
          if(val === '' || val === 'registered'){
          this.setFalse()
        } else {
          this.setTrue();
        }
        }
        
        console.log(this.goshalas.length);
        // console.log("In Json Format: " + res.json())
        
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
    }

  goToFarmDashboardPage(goshala){
    if(this.myApp.isLoggedIn && (this.myApp.access.role === 'Admin' || (this.myApp.access.goshalaId === goshala.id) || ((this.myApp.access.role === 'Continental Representative' && this.myApp.access.roleContinent === goshala.continent) || (this.myApp.access.role === 'Representative' && this.myApp.access.roleCountry === goshala.country)))){
      this.navCtrl.push(FarmDashboardPage, {
        goshala: goshala
      });
    }
  }

  goToAddFarmPage(){

    this.navCtrl.push(AddFarmPage, {type: "Add Farm"});
  }

  getStats(){
    // this.presentLoading()
    this.dbService.fetchDataV2('SELECT * FROM dashboardFarms')
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.stat=res.data[0];
        this.getContinents();
        // console.log(this.goshalas);
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  getGoshalas(){
    // this.presentLoading()
    this.dbService.fetchDataV2('SELECT f.* FROM farms f where f.id != 0 ORDER BY f.continent, f.name')
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.goshalas=res.data;
        console.log(this.goshalas);
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  getContinents(){
    this.presentLoading()
    this.dbService.fetchDataV2('SELECT * from dashboardContinent;')
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();

        this.continents=res.data;
        console.log(this.continents);
        this.setFalse()
        console.log(this.continents);
        this.getGoshalas()
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }

  setFalse(){
    let i;
    for(i = 0; i < this.continents.length; i++){
      this.continents[i].clicked = false;
    }
  }

  setTrue(){
    let i;
    for(i = 0; i < this.continents.length; i++){
      this.continents[i].clicked = true;
    }
  }

  hideList(i){
    if(this.continents[i].clicked === undefined || this.continents[i].clicked === false){
      this.continents[i].clicked = true;
    return console.log(this.continents[i].continent + ": " + this.continents[i].clicked)
    }
    if(this.continents[i].clicked === true){
      this.continents[i].clicked = false;
     return console.log("this.continents[i].continent: " + this.continents[i].clicked)
    }

  }

//   getGoshalas(){
//     //Create Headers for POST
//       var headers = new Headers();
//       headers.append("Accept", 'application/json');
//       headers.append('Content-Type', 'application/json' );
//       headers.append('Access-Control-Allow-Origin', '*' ); 
//       const requestOptions = new RequestOptions({ headers: headers });

//     //Encyption
//       this.string2encyrpt = '{"sql": "select * from farms", "lock": "krishna108"}'
//       this.key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789xxxxxx");
//       this.iv  = CryptoJS.enc.Hex.parse("yyyyyy9876543210abcdef9876543210");
//       var encrypted = CryptoJS.AES.encrypt(this.string2encyrpt, this.key, {
//                   iv: this.iv  
//                 });
//       this.myencryption = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
//       //console.log("Encypted data : " + this.myencryption);

//     //Generate Form to Post
//     let postData = new FormData();
//       postData.append('data',this.myencryption);

//     //Site to post data to 
//     this.http.post("https://dev-x.co.za/MayapurIT/Goshala/cowdb1.php", postData)
//       .map(res => res.json())
//       .subscribe(res => {
//         //console.log(data['_body']);
//         this.goshalas= res.data;
//         console.log(this.goshalas);
//       }, error => {
//         alert("FAILED, to fetch from php : "+ error);
//         this.myreturnvalue = "Error : " + error;
//         console.log(this.myreturnvalue)
//       }); 
//  }



  // getGoshalas(){
  //   this.http.get("https://www.dev-x.co.za/MayapurIT/Goshala/cowdb.php?key=get&mysql=select * from farms")
  //   .map(res => res.json())
  //   .subscribe(res => {
  //     this.goshalas = res.data; 
  //     console.log("Jason data: " + res.data);
  //     console.log("Temple Array : " + this.goshalas);
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }


  // deleteGoshala(goshala){
  //   this.myApp.key = "delete";
  //   console.log("INGoshalas : " + "http://localhost/GoshalaRoutes.php?Goshala_ID=" + goshala.Goshala_ID + "&key=" + this.myApp.key);
  //   this.http.get("http://localhost/GoshalaRoutes.php?Goshala_ID=" + goshala.Goshala_ID + "&key=" + this.myApp.key)
  //   .map(res => res)
  //   .subscribe(res => {
  //      alert("Deleted" + res);
  //      this.navCtrl.push(GoshalasListPage, {
  //        goshala: this.navParams.get("goshalas")
  //      });
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }

}



// WEBPACK FOOTER //
// ./src/pages/farms/farmList/farmList.ts